import { GenericResponse } from '../GenericResponse';

export type UserPlatform = 'ADVOCATE' | 'EMPLOYER';
export const EmployerRole = 'EMPLOYER';

export type LoginMeta = {
  email: string;
  password: string;
  fromSignup?: boolean;
};

export type LoginPayload = GenericResponse & {
  fromSignup?: boolean;
};
